module.exports = __webpack_public_path__ + "static/media/codexar.fea2817f.png";